<template>
  <div class="widget-form local-widget-form">
    <div class="container">
      <div class="row center-lg">
        <div class="col-xs-12">
          <div class="form-wrapper">
            <div class="form-title align-left">
              Den Preis für dein Auto <br/>in <span class="highlight">1 Minute</span> erfahren
            </div>
            <div class="configurator-wrapper">
              <Preselector />
              <button type="button" class="go-to-wizard" @click="makeRedirect" name="Submit"><i class="fas fa-map-marker"></i> <span>Kostenlose Preisbewertung</span><i class="fas fa-arrow-right"></i></button>
            </div>
            <div class="note">
              TÜV Rheinland verifiziert 
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import Preselector from './Preselector';

import 'vue-select/dist/vue-select.css';
import { Api } from '../services/api'
import { redirectToEvaluationNew } from '../services/helpers';

export default {
  name: "ContentWidgetForm",
  components: {
      vSelect,
      Preselector
  },
  data() {
  return {
    showModal: {
      widget: false,
    },
  }
},
  methods: {
    makeRedirect() {        
      redirectToEvaluationNew(this.$store, true, 'trade_in', 'local_lp');
    },
  },
  mounted: function() {
    Api.get(this.$store, this.$store.state.step);
  },
}
</script>

<style lang="scss" scoped>
  @import "~@/assets/vars";

  .widget-form.local-widget-form {
    position:relative;
    background:$light-gray;
    @include breakpoint(frommediumlarge) {
      box-shadow: 0 0 24px rgba(0, 0, 0, 0.1);
    }

    @include breakpoint(fromgiant) {
      background:transparent;
      box-shadow:none;
    }

    i.fa-map-marker {
      font-weight: 400;
      font-family: 'FontAwesome';
    }

    .form-wrapper {
      position:relative;
        border-radius:10px;
        padding-top:25px;
        padding-bottom:50px;
        z-index:10;
        @include breakpoint(fromlarge) {
          padding-top:60px;
          padding-bottom:60px;
        }
        
        @include breakpoint(fromgiant) {
          margin-top:-143px;
          padding-top:50px;
          padding-bottom:50px;
          padding-left:50px;
          padding-right:50px;
          box-shadow: 0 0 24px rgba(0, 0, 0, 0.1);
          background:$light-gray;
        }
        @include breakpoint(extralarge) {
          padding-left:80px;
          padding-right:80px;
        }
        @include breakpoint(full) {
          padding-left:30px;
          padding-right:30px;
        }
        @media screen and (min-width:993px) and (max-height:830px) {
          padding-top:50px;
          padding-bottom:30px;
        }
        @media screen and (min-width:993px) and (max-height:750px) {
          padding-top:30px;
          padding-bottom:30px;
        }

        .form-title {
            font-size: 25px;
            line-height:30px;
            margin-bottom:24px;
            font-weight:600;
            text-align:center;
            @include breakpoint(fromlarge) {
              font-size:30px;
              line-height:34px;
              br {
                display:none;
              }
            }
            @include breakpoint(fromgiant) {
              font-size: 40px;
              line-height:48px;
            }
            @include breakpoint(extralarge) {
              font-size: 45px;
              line-height:52px;
            }
        }

        .configurator-wrapper {
          @include breakpoint(fromlarge) {
              display:flex;
              justify-content: space-between;
              gap:20px;
            }
          @include breakpoint(extralarge) {
            gap: 40px;
          }
          button.go-to-wizard {
            width:100%;
            max-height: 74px;
            border-radius:0;
            white-space:nowrap;
            font-size:17px !important;
            line-height: 20px !important;
            padding:12px 0 !important;
            max-height: 60px;
            > i {
              padding-left: 10px;
            }
            @include breakpoint(fromlarge) {
              width:25%;
              margin-bottom:0;
              border-radius: 40px;
              font-size:15px !important;
              line-height: 17px !important;
            }
            @include breakpoint(fromgiant) {
              width:25%;
              font-size:17px !important;
              line-height: 20px !important;
            }

            @include breakpoint(extralarge) {
              font-size:15px !important;
              line-height: 17px !important;
            }

            @include breakpoint(full) {
              font-size:17px !important;
              line-height: 20px !important;
            }
          }
        }

        .note {
          display:flex;
          justify-content: center;
          margin-top:10px;
          font-size: 14px;
          line-height: 20px;

          @include breakpoint(fromlarge) {
              justify-content: flex-end;
              width: calc(25% - 10px);
              display:block;
              text-align:center;
              margin-right:30px;
              margin-left:auto;
              white-space: nowrap;
          }

          @media (min-width: 1100px) {
              margin-right:0;
          }
        }
    }
  }
</style>



// WEBPACK FOOTER //
// src/local-components/ContentWidgetForm.vue